export interface SheetElement {
  hidden: boolean | string;
  classList: Pick<DOMTokenList, 'toggle' | 'contains'>;
  setAttribute(name: string, value: string): void;
}

/** Keeps semantic visibility and the animated/open styling state in sync. */
export function setSheetOpen(element: SheetElement, open: boolean): void {
  element.hidden = !open;
  element.classList.toggle('open', open);
  element.setAttribute('aria-hidden', String(!open));
}
